<div>
	<mat-card appearance="outlined">
		<mat-card-title style="margin: 15px;">
			Complaints Summary
		</mat-card-title>
		<mat-card-content>
			<div class="search-container">
				<form [formGroup]="summaryForm">
					<div class="search-section">
						<mat-form-field appearance="outline" style="margin-right: 10px;">
							<mat-label>Department</mat-label>
							<mat-select formControlName="departmentId" placeholder="Department" required>
								<mat-option *ngFor="let department of departments" [value]="department.code">
									{{ department.value }}
								</mat-option>
							</mat-select>
							<mat-error *ngIf="summaryForm.controls.departmentId.hasError('required')">Department is required</mat-error>
						</mat-form-field>

						<mat-form-field appearance="outline">
							<mat-label>Enter a date range</mat-label>
							<mat-date-range-input [formGroup]="summaryForm" [rangePicker]="picker">
								<input matStartDate formControlName="startDate" placeholder="Start date" required>
								<input matEndDate formControlName="endDate" placeholder="End date" required>
							</mat-date-range-input>
							<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
							<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
							<mat-date-range-picker #picker></mat-date-range-picker>
							<mat-error *ngIf="summaryForm.controls.startDate.hasError('required') || summaryForm.controls.startDate.hasError('matStartDateInvalid')">
								Start date is required and must be valid
							</mat-error>
							<mat-error *ngIf="summaryForm.controls.endDate.hasError('required') || summaryForm.controls.endDate.hasError('matEndDateInvalid')">
								End date is required and must be valid
							</mat-error>
						</mat-form-field>

						<div style="margin-left: 12px; display:flex; align-items:center;" *ngIf="isToggleVisible">
							<label style="margin-right:8px; font-size:14px;">Restrict Filters</label>
							<mat-slide-toggle formControlName="restrictResults" color="primary"></mat-slide-toggle>
						</div>
					</div>
				</form>
				<div style="margin-top: 20px; text-align: center;">
					<button mat-stroked-button color="warn" (click)="onReset()">Reset</button>
					<button style="margin-left: 10px;" mat-flat-button color="primary" [disabled]="!isFormValid() || isLoading" (click)="generateSummaryReport()">
						{{ isLoading ? 'Generating...' : 'Generate Report' }}
					</button>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>
